<template>
    <b-modal id="client_delete" ref="client_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="setTitle">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('client_delete')" v-text="'Cancel'"/>

            <state-button size="sm" v-if="mode === 'client'" variant="danger" :click="deleteClient">Delete</state-button>

            <state-button size="sm" v-else variant="danger" :click="deleteComment">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
    import StateButton from "../../../../../components/Common/StateButton";

    export default {
        name: "ClientDeleteModal",

        components: {
            StateButton,
        },

        props: [
            'client', 'comment', 'mode',
        ],

        data() {
            return {

            }
        },

        computed: {
            setTitle() {
                if (this.mode === 'client') {
                    return 'Delete ' + this.client.data.attributes.name + '?';
                } else {
                    return 'Delete comment?';
                }
            },
        },

        methods: {
            deleteClient() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('deleteClient', this.client)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('deleted-client');

                                this.$notify('error filled', 'Success!', 'Deleted the client!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('client_delete');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            deleteComment() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('deleteClientComment', this.comment)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('deleted-comment');

                                this.$notify('error filled', 'Success!', 'Deleted the comment!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('client_delete');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },
        },
    }
</script>

<style scoped>

</style>
